module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAdVBMVEXmV1fmV1fmV1fmV1fmV1fmV1fmV1dHcEzmV1fmV1fmV1fmV1fmV1fmV1fzX1/mV1fmV1fmV1fyX1/mV1fmV1fzX1/zX1/xXV3yXl7zX1/mV1fmV1fvXFzmV1fyXl7xXl7uXFzyXl7yXl7yXl7uXFzzX1/zX1/mIwmwAAAAJnRSTlMDAg0UBwUEAAEaCQ4dDPQ2JC2KDyjBxaPS+EBFcDLLV3xTUld99a8+dO4AAACgSURBVBjTXY/ZFoMgDEQDAhJlEfe1e/3/Tyyp0ofOU+aek2QG8ijNQClgmmaIFuS9c657SNAENIh6/6oWkUAO4rqfeopoteR9Aj2XGliRuQRcVjAAiz/wRgugSnNJ4GJKRWBNYCUQV8Jw+CHQSjxa+dc4TePNV3Q0vsXWz8sy+xbpbQzWYBW2LVTYUDCKzjM0BjN+RKdyhS1LW5zl/up/AMDCELkXqw88AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/styles/common/img/new.png
// module id = zQNv
// module chunks = 37